import { useEffect } from 'react';

import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';

import { IPurchaseChartInfoData } from '@entities/purchase/model/index.types';

/*
 * Временный хук для связи с событиями из легаси
 * */

export const useConnectWithLegacy = ({
    refetch,
}: {
    refetch: (options?: RefetchOptions) => Promise<QueryObserverResult<IPurchaseChartInfoData>>;
}) => {
    useEffect(() => {
        const controller = new AbortController();
        const { signal } = controller;

        const handled = new Set<number>();
        const onReady = async (e: Event) => {
            const { needToRefetch, dateNow } = (e as CustomEvent).detail ?? {};
            if (!needToRefetch) return;
            if (dateNow && handled.has(dateNow)) return;
            if (dateNow) handled.add(dateNow);

            await refetch({ cancelRefetch: false });
        };

        const events = [
            'legacy:updatePurchaseAmountAndPrice:ready',
            'legacy:purchaseAccordingToEstimate:ready',
            'legacy:updateExcessPrice:ready',
            'legacy:setAccordingToEstimate:ready',
            'legacy:statusManagerSaveStatus:ready',
            'legacy:addPaymentRequestForChecks:ready',
            'legacy:removeCheckUrl:ready',
            'legacy:removeExcessPosition:ready',
            'legacy:positionCloseUrl:ready',
            'legacy:dnd:positionDropped:ready',
        ];

        events.forEach((eventName) => {
            window.addEventListener(eventName, onReady, { signal });
        });
        return () => {
            controller.abort();
        };
    }, [refetch]);
};
